<script>
import Base from '@/plans/ROOM_CONNECTOR/config/base';
import baseplanFreeToPaidReplenishMixin from "@/components/capacity/mx/freetrial-baseplan-replenish";

export default {
  extends: Base,
  mixins: [baseplanFreeToPaidReplenishMixin],
  data() {
    return {
      showCycleAlert: true,
    }
  },
};
</script>
